// extracted by mini-css-extract-plugin
export default {"description":"styles_description__OYvQT"};